import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main/components/main/main.component';
import { CriticalErrorComponent } from './shared/components/critical-error/critical-error.component';
import { LoginComponent } from './shared/components/login/login.component';
import { MaintenanceComponent } from './shared/components/maintenance/maintenance.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { SsoComponent } from './shared/components/sso/sso.component';
import { UnauthorizedComponent } from './main/unauthorized/unauthorized.component';
import { AuthGuard } from './shared/guards/auth.guard';

export enum SsoResourcesNavigationType {
  OnlineCourse = 'online-course',
  ProductSheet = 'product-sheet',
}

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login'
    }
  },
  {
    path: 'sso/login',
    component: SsoComponent,
  },
  {
    path: 'sso/resources',
    children: [
      {
        path: 'online-courses/:onlineCourseId',
        component: SsoComponent,
        data: {
          ssoResourceNavigationType: SsoResourcesNavigationType.OnlineCourse,
        },
      },
      {
        path: 'product-sheets/:productSheetId',
        component: SsoComponent,
        data: {
          ssoResourceNavigationType: SsoResourcesNavigationType.ProductSheet,
        },
      },
    ],
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent,
    data: {
      title: 'Manutenzione'
    }
  },
  {
    path: 'app',
    loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
    canActivate: [AuthGuard]
  },
  {
    path: '404',
    component: NotFoundComponent,
    data: {
      title: 'Pagina non trovata'
    }
  },
  {
    path: 'critical-error',
    component: CriticalErrorComponent,
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    canActivate: [
      //AuthGuard,
    ],
    data: {
      title: 'Accesso non autorizzato'
    }
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      relativeLinkResolution: 'corrected',
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
      // enableTracing: true, // Only for debug
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
